<div class="contentMain">
  <!-- breadcrumb -->
  <!--/ breadcrumb-->
  <!-- main body -->
  <main class="row">
    <!-- card -->
    <div class="card">
      <div class="card-header mainheader header-container-btn">
        <h5>Area Creation - New Mode</h5>
      </div>
      <div class="card-body">
        <!-- row -->
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="d-flex">
              <p class="pb-0 mb-0">Status</p>
              <div class="checkbox ml-3">
                <input id="activestatus" type="checkbox" />
                <label for="activestatus"> Active </label>
              </div>
            </div>
          </div>
          <!-- col -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="form-group">
              <div class="form-group">
                <label>Area Name</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Area Name"
                />
              </div>
            </div>
          </div>
          <!--/ col -->
          <!-- col -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="form-group">
              <div class="form-group">
                <label>Area Code</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Area Code"
                />
              </div>
            </div>
          </div>
          <!--/ col -->
          <!-- col -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="form-group">
              <div class="form-group">
                <label>Pin Code</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Pin Code"
                />
              </div>
            </div>
          </div>
          <!--/ col -->
          <!-- col -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="form-group">
              <label> Under</label>
              <select
                class="form-control show-tick ms select2"
                data-placeholder="Select"
              >
                <option>Select Under</option>
                <option>Select Item1</option>
                <option>Select Item2</option>
                <option>Select Item3</option>
                <option>Select Item4</option>
              </select>
            </div>
          </div>
          <!--/ col -->
          <!-- col -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="form-group">
              <label>District</label>
              <select
                class="form-control show-tick ms select2"
                data-placeholder="Select"
              >
                <option>Select District</option>
                <option>Select Item1</option>
                <option>Select Item2</option>
                <option>Select Item3</option>
                <option>Select Item4</option>
              </select>
            </div>
          </div>
          <!--/ col -->
          <!-- col -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="form-group">
              <label>State</label>
              <select
                class="form-control show-tick ms select2"
                data-placeholder="Select"
              >
                <option>Select State</option>
                <option>Select Item1</option>
                <option>Select Item2</option>
                <option>Select Item3</option>
                <option>Select Item4</option>
              </select>
            </div>
          </div>
          <!--/ col -->
          <!-- col -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="form-group">
              <label>Country</label>
              <select
                class="form-control show-tick ms select2"
                data-placeholder="Select"
              >
                <option>Select Country</option>
                <option>Select Item1</option>
                <option>Select Item2</option>
                <option>Select Item3</option>
                <option>Select Item4</option>
              </select>
            </div>
          </div>
          <!--/ col -->
          <!-- col -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="form-group">
              <label>Salesman</label>
              <select
                class="form-control show-tick ms select2"
                data-placeholder="Select"
              >
                <option>Select Salesman</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
                <option>6</option>
              </select>
            </div>
          </div>
          <!--/ col -->
        </div>
        <!-- /row -->
      </div>
      <div class="card-footer text-left w-100">
        <button class="btn redbtn" type="button">F3-save</button>

        <button class="btn redbtn" [routerLink]="['/createArea']" type="button">
          cancel
        </button>
        <button class="btn redbtn" type="button">Help</button>
      </div>
    </div>
  </main>
</div>
